/**
 * PATH: apps/qa/src/pages/area-execution/ItemCardPhotoSources.tsx
 * FILE_ID: QA-HUB-ITEM-PHOTO-SOURCES-001
 * PURPOSE: QDrive + HEIC photo source beside the existing ItemCard camera button.
 */
import { QaPhotoSourceMenu } from '@quotech/job-hub/jobs/qa'
import { listQaQDriveFiles } from '@/lib/qaQDriveList'

export function ItemCardPhotoSources({
  busy,
  onPickFile,
  onPickAsset,
}: {
  busy?: boolean
  onPickFile: (file: File) => void | Promise<void>
  onPickAsset: (assetId: string, filename?: string) => void | Promise<void>
}) {
  return (
    <QaPhotoSourceMenu
      busy={busy}
      listQDriveFiles={listQaQDriveFiles}
      onPickFile={onPickFile}
      onPickAsset={onPickAsset}
    />
  )
}
